<template>
  <GestionEventosPendientes />
</template>
<script>
import GestionEventosPendientes from "./components/GestionEventosPendientes.vue";
export default {
  name: "EventosPendientes",
  components: { GestionEventosPendientes }
};
</script>